// extracted by mini-css-extract-plugin
module.exports = {"contacts":"style_contacts__3Y8Wl","close-label":"style_close-label__1yiho","close-button":"style_close-button__3-eYH"};